// extracted by mini-css-extract-plugin
export default {"root":"IconCouch_root__6D9TN"};